// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui-button[data-v-37312e71] {\n  white-space: normal;\n}\n.btn[data-v-37312e71]:disabled {\n  cursor: not-allowed;\n}\n.btn.btn-link[data-v-37312e71] {\n  padding: 0;\n  background-color: transparent;\n  color: var(--dark);\n  font-weight: 300;\n  text-decoration: none;\n}\n.btn.m-subheader-search__submit-btn[data-v-37312e71] {\n  padding: 1.05rem 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
